import script from "./ImagemComponente.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagemComponente.vue?vue&type=script&setup=true&lang=js"

import "./ImagemComponente.vue?vue&type=style&index=0&id=2f1c1bbb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1c1bbb"]])

export default __exports__